"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var styles = {
  root: {
    position: 'relative'
  },
  highlight: {
    background: function background(_ref) {
      var color = _ref.color;
      return color;
    },
    borderRadius: '3px',
    opacity: function opacity(_ref2) {
      var isActive = _ref2.isActive;
      return isActive ? 0.1 : 0;
    },
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    transition: '0.2s opacity'
  }
};
var _default = styles;
exports["default"] = _default;